<template>
  <div class="scroll">
    <table class="tableHours">
      <thead class="thead">
        <tr class="column-main">
          <th v-for="column of columns" :key="column" class="column-main-title">
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody class="tbody">
        <tr v-for="(i, index) of data" :key="index" class="column-content">
          <td
            v-for="column of columns"
            :key="column"
            class="column-content-title"
          >
            <span v-if="column.value === 'day'">
              {{ getFullDay(index) }}
            </span>
            <Checkbox
              v-if="column.value === 'closed'"
              v-model="i.closed"
              :value="i.closed"
              @change="changeClosed(index)"
            />
            <TimePicker
              v-if="column.value === 'startAt'"
              :selected-time="checkClosed ? '' : i.from"
              :class="{ disabledInput: i.closed }"
              :disabled="i.closed"
              @update-time="updateHours('startAt', $event.target.value, index)"
            />
            <TimePicker
              v-if="column.value === 'endAt'"
              :selected-time="checkClosed ? '' : i.to"
              :class="{ disabledInput: i.closed }"
              :disabled="i.closed"
              @update-time="updateHours('endAt', $event.target.value, index)"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div ref="observer" class="observer"></div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'TableHours',
  props: ['data', 'columns'],
  data() {
    return {
      closed: false,
      checkClosed: false
    };
  },
  methods: {
    getFullDay(day: string) {
      const daysMap: Record<string, unknown> = {
        mon: this.$t('monday'),
        tue: this.$t('tuesday'),
        wed: this.$t('wednesday'),
        thu: this.$t('thursday'),
        fri: this.$t('friday'),
        sat: this.$t('saturday'),
        sun: this.$t('sunday')
      };

      return daysMap[day];
    },
    changeClosed(day: string) {
      this.data[day].closed = !this.data[day].closed;

      if (this.data[day].closed) {
        this.data[day].from = '';
        this.data[day].to = '';
      }

      this.closed = this.data[day].closed;
    },
    updateHours(
      startOrEnd: 'startAt' | 'endAt',
      newHour: string,
      index: number
    ) {
      if (startOrEnd === 'startAt') {
        this.data[index].from = newHour;
      } else if (startOrEnd === 'endAt') {
        this.data[index].to = newHour;
      }
    }
  },
  mounted() {
    const options = {
      rootMargin: '0px',
      threshold: 1.0
    };

    const callback = (entries: IntersectionObserverEntry[]) => {
      const lastElement = this.data[this.data?.length - 1];
      if (entries[0].isIntersecting && lastElement) {
        this.$emit('loadMore', lastElement.id || lastElement);
      }
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(this.$refs.observer);
  }
})
export default class TableHours extends Vue {}
</script>

<style scoped lang="scss">
.scroll {
  overflow: auto;
  height: 100%;
  .tableHours {
    width: 100%;
    border-collapse: collapse;
    .thead {
      .column-main {
        text-align: left;
        .column-main-title {
          position: sticky;
          top: 0;
          font-family: 'Ubuntu-Medium';
          font-size: $tenSize;
          line-height: $thirteenSize;
          background: $white;
          color: $columnMainTitle;
          padding: 20px 10px;
          letter-spacing: 2px;
        }
        .column-main-img {
          position: sticky;
          top: 0;
          width: 25px;
          background: $white;
        }
      }
    }
    .tbody {
      overflow-y: scroll;
      .column-content {
        border-top: 1px solid $borderTopLine;
        height: 46px;
        &:hover {
          cursor: pointer;
        }
        &:hover .column-content-title {
          background-color: $light-grey;
        }
        &:hover .column-content-title span {
          background-color: $light-grey;
        }

        &:hover .column-content-img {
          background-color: $light-grey;
        }

        .column-content-title {
          padding: 13px 10px;
          font-size: $fourteenSize;
          line-height: 20px;
          vertical-align: middle;
          color: $columnContentTitle;
        }
        &:hover .imgSeeValue {
          opacity: 1;
        }

        .column-content-img {
          vertical-align: middle;
          padding: 5px;
          .img {
            height: 18px;
            width: 18px;
            opacity: 0;
            margin: 0 5px;
          }
        }
      }
    }
    .observer {
      height: 10px;
      margin-top: 100px;
      background: transparent;
    }
  }
}

.table > :not(:first-child) {
  border-top: none;
}
</style>
